import { render } from "./Pagination.vue?vue&type=template&id=2ca85d63"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"
script.render = render

export default script